module.exports = __webpack_public_path__ + "fonts/UcCm3FwrK3iLTcvnUwoT9mI1F55MKw.183e93c.woff2";